module.exports = __webpack_public_path__ + "assets/img/4.d809d4a8.png";